export default __webpack_public_path__ + "static/media/aveled-logo-invert.ee1301e9.png";